import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { getDomainConfig } from './config';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import CategoryPage from './pages/CategoryPage';
import ProductPage from './pages/ProductPage';
import SearchPage from './pages/SearchPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import ReturnPolicyPage from './pages/ReturnPolicyPage';
import ShippingPolicyPage from './pages/ShippingPolicyPage';
import FAQPage from './pages/FAQPage';
import CategoriesPage from './pages/CategoriesPage';
import EmailPage from './pages/EmailPage';
import './App.css';

// GTM Page View Tracker
function useGTMPageTracking() {
  const location = useLocation();

  useEffect(() => {
    // Push page view to GTM dataLayer
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'pageview',
        page: {
          path: location.pathname + location.search,
          title: document.title,
          url: window.location.href
        }
      });
    }
  }, [location]);
}

function AppContent({ domainConfig }) {
  // Track page views via GTM dataLayer
  useGTMPageTracking();

  return (
    <div className="App" style={{ '--primary-color': domainConfig.primaryColor }}>
      <Header config={domainConfig} />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<HomePage config={domainConfig} />} />
          <Route path="/categories" element={<CategoriesPage />} />
          <Route path="/category/:id" element={<CategoryPage />} />
          <Route path="/products/:id" element={<ProductPage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/returns" element={<ReturnPolicyPage />} />
          <Route path="/shipping" element={<ShippingPolicyPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/email" element={<EmailPage />} />
        </Routes>
      </main>
      <Footer config={domainConfig} />
    </div>
  );
}

function App() {
  const domainConfig = getDomainConfig();

  return (
    <HelmetProvider>
      <Router>
        <AppContent domainConfig={domainConfig} />
      </Router>
    </HelmetProvider>
  );
}

export default App;
